import { render, staticRenderFns } from "./NextcloudPhpOpcache.vue?vue&type=template&id=51253a44&scoped=true&"
import script from "./NextcloudPhpOpcache.vue?vue&type=script&lang=js&"
export * from "./NextcloudPhpOpcache.vue?vue&type=script&lang=js&"
import style0 from "./NextcloudPhpOpcache.vue?vue&type=style&index=0&id=51253a44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51253a44",
  null
  
)

export default component.exports